import { useEffect } from 'react';
import { prop, isEmpty, pick } from 'ramda';
import { useAppSelector, useCookieSettingsSelector } from 'js/store/hooks';

import * as helpers from '../helpers';

export const useRemoveCookies = () => {
    const { groupsData, removeCookiesInterval } = useCookieSettingsSelector(pick(['groupsData', 'removeCookiesInterval']));
    const { cookieGroups, enableCookiesAdmission } = useAppSelector(prop('cookiesConfiguration'));

    useEffect(() => {
        if (!enableCookiesAdmission || isEmpty(groupsData)) {
            return;
        }

        const cookiesData = helpers.getCookiesList(cookieGroups, groupsData);

        if (!cookiesData.length) {
            return;
        }

        helpers.clearCookies(cookiesData);

        const intervalId = setInterval(() => {
            helpers.clearCookies(cookiesData);
        }, removeCookiesInterval);

        return () => clearInterval(intervalId);
    }, [groupsData, cookieGroups, enableCookiesAdmission, removeCookiesInterval]);
};
